module.exports = __webpack_public_path__ + "static/media/calendario-2023-i-int.8ab47a9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendario-2023-i-int.jpg
// module id = 833
// module chunks = 0